import { handleClickCard } from "../../../../functions/functions";
import renderPeriod from "./renderPeriod";
import "./footerCardListSponsored.sass";

/**
 * Muestra el footer de una tarjeta de evento patrocinado, incluyendo botón de apuesta,
 * estatus del evento y nombre de la liga.
 */
export default function FooterCardListSponsored({ liga, opta_event_url, patrocinador, clase, activeMomios, statusEvent, item }) {

  const patrocinadorKey = patrocinador?.toLowerCase().replace(/\s+/g, '-') || '';
  const patrocinadorMetadata = item?.[`${patrocinadorKey}_metadata`] || {};

  const isActive = activeMomios && !["clarosports-finished-game", "clarosports-error-game"].includes(clase);
  const classPatrocinador = `apostar-${patrocinadorKey}`;

  return (
    <a href={opta_event_url} target="_parent" rel="noreferrer" className="card-list-sponsored__footer">
      {/* Botón de apuesta o marcador vacío */}
      <div className="card-list-sponsored__footer-btn">
        {isActive ?
          <button
            type="button"
            onClick={(e) => handleClickCard(e, patrocinadorMetadata.url_mm_evento)}
            title={patrocinadorMetadata.url_mm_evento}
            className={`card-list-sponsored__footer ${classPatrocinador}`}
          >
            Juega aquí
          </button>
          : <span className="card-list-sponsored__footer-empty" />
        }
      </div>

      {/* estatus del partido */}
      <div className="card-list-sponsored__footer-status">
        {renderPeriod(clase, statusEvent)}
      </div>

      {/* liga */}
      <p className="card-list-sponsored__footer-league">{liga}</p>
    </a>
  )
}

